import styled from '@emotion/styled';
import { defaultContainerSize, mq } from '../../../styles/mixins';
import { css } from '@emotion/react';

export const Wrapper = styled.section`
  background-color: ${({ theme }) => theme.colors.light_grey};
`;

export const Inner = styled.div`
  ${defaultContainerSize};
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${mq.medium(css`
    padding-left: 3rem;
    padding-right: 3rem;
  `)};

  ${mq.large(css`
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  `)};

  ${mq.xLarge(css`
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  `)};
`;

export const Title = styled.h1`
  font-family: ${({ theme }) => theme.font.questrial};
  font-style: normal;
  font-weight: normal;
  font-size: 2rem;
  line-height: 3.5rem;
  letter-spacing: -0.013rem;
  color: ${({ theme }) => theme.colors.core_black};
  margin: 4rem 0 2rem 0;

  ${mq.medium(css`
    font-size: 3rem;
    margin: 5rem 0 2rem 0;
  `)};

  ${mq.xLarge(css`
    font-size: 3rem;
    margin: 5rem 0 0 0;
  `)};
`;

export const Icons = styled.div`
  display: grid;
  column-gap: 1.125rem;
  row-gap: 1.125rem;
  grid-template-columns: repeat(5, 2.5rem);
  grid-template-rows: repeat(2, 2.5rem);
  margin-bottom: 5rem;
  margin-top: 2rem;
  justify-content: center;

  ${mq.medium(css`
    margin-bottom: 5.5rem;
    column-gap: 2rem;
    row-gap: 2.5rem;
    grid-template-columns: repeat(5, 3.875rem);
    grid-template-rows: repeat(2, 3.875rem);
    margin-top: 2.5rem;
  `)};

  ${mq.large(css`
    margin-bottom: 5.5rem;
    column-gap: 2rem;
    row-gap: 2.5rem;
    grid-template-columns: repeat(5, 6.875rem);
    grid-template-rows: repeat(2, 6.875rem);
    margin-top: 3.5rem;
  `)};

  ${mq.xLarge(css`
    column-gap: 1.438rem;
    row-gap: 1.5rem;
    grid-template-columns: repeat(10, 6rem);
    grid-template-rows: repeat(1, 6rem);
    margin-bottom: 7.5rem;
    margin-top: 4.375rem;
  `)};
`;

export const Icon = styled.div`
  width: 2.5rem;

  ${mq.medium(css`
    width: 3.875rem;
  `)};

  ${mq.large(css`
    width: 6.875rem;
  `)};

  ${mq.xLarge(css`
    width: 6rem;
  `)};
`;
